import React from "react";
import ResetPasswordBox from "../components/ResetPassword/ResetPassword";

function ResetPassword() {
  return (
    <section>
      <ResetPasswordBox />
    </section>
  );
}

export default ResetPassword;
